import { render, staticRenderFns } from "./TopAlert.vue?vue&type=template&id=7a51a112&scoped=true"
import script from "./TopAlert.vue?vue&type=script&lang=js"
export * from "./TopAlert.vue?vue&type=script&lang=js"
import style0 from "./TopAlert.vue?vue&type=style&index=0&id=7a51a112&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a51a112",
  null
  
)

export default component.exports